<template>
  <v-dialog v-model="dialog" max-width="1400px" persistent scrollable>
    <v-card>
      <v-card-title class="headline white--text" style="background: var(--especialidade-primary, #2e4b9d);">
        <v-icon left color="white">mdi-account-edit</v-icon>
        Editar Paciente
        <v-spacer></v-spacer>
        <v-btn icon dark @click="fecharModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <validation-observer ref="observer" v-slot="{ }">
          <form ref="form" @submit.prevent="salvar">
            <v-row>
              <v-col md="12" sm="12" xs="12" class="d-flex justify-md-center">
                <soi-avatar-input
                  tipo="paciente"
                  :paciente-id="paciente.id"
                  :fotoKey.sync="paciente.foto"
                  v-model="paciente.file"
                  @apagarFoto="apagarFoto">
                </soi-avatar-input>
              </v-col>
            </v-row>
            <h3>Dados Pessoais</h3>
            <soi-dados-padrao-paciente
              v-model="paciente"
              :cpfObrigatorio="tenant.clinica.moduloConfiguracaoCampos.habilitarCpf">
            </soi-dados-padrao-paciente>
            <soi-endereco v-model="paciente.endereco"></soi-endereco>
            <soi-contato v-model="paciente.contato"></soi-contato>
            <soi-pacienteconvenio
              v-model="pacienteConvenioPrincipal"
              titulo="Convênio Principal">
            </soi-pacienteconvenio>
            <soi-pacienteconvenio
              v-model="pacienteConvenioSecundario"
              titulo="Convênio Secundário">
            </soi-pacienteconvenio>
            <v-row class="d-flex justify-md-center">
              <v-col md="11" sm="10" xs="10">
                <v-textarea
                  label="Observação"
                  counter="500"
                  :bg-color="(paciente.observacaoPaciente?.length || 0) >= 500 ? 'red' : 'light-blue'"
                  v-model="paciente.observacaoPaciente"
                  outlined>
                </v-textarea>
              </v-col>
            </v-row>
          </form>
        </validation-observer>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4 d-flex justify-end">
        <v-btn color="error" @click="fecharModal" :disabled="carregando" class="mr-2">
          <v-icon left>mdi-cancel</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          :loading="carregando"
          :disabled="carregando"
          class="white--text"
          style="background: var(--especialidade-primary, #2e4b9d);"
          @click="salvar">
          <v-icon left>mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import Pacientes from '../../models/pacientes/Pacientes';
import { PacientesService } from '../../services/PacientesService';
import DateHelper from '../../helpers/DateHelper';
import { AlertaSimplesErro, MensagemMixin } from '../../helpers/MensagemHelper';
import PacientesConvenio from '../../models/convenio/PacientesConvenio';
import { PlanoService } from '../../services/PlanoService';
import FormData from 'form-data';
import { TenantService } from '@/services/TenantService';
import Tenant from '@/models/tenant/Tenant';

export default Vue.extend({
  name: 'ModalEditarPaciente',
  data() {
    return {
      dialog: false,
      paciente: new Pacientes(),
      carregando: false,
      pacienteConvenioPrincipal: new PacientesConvenio(),
      pacienteConvenioSecundario: new PacientesConvenio(),
      tenant: new Tenant(),
      tenantService: new TenantService(),
      pacientesService: new PacientesService(),
      planoService: new PlanoService(),
    };
  },
  methods: {
    async abrirModal(pacienteId: number) {
      this.dialog = true;
      this.carregando = true;
      try {
        const resTenant = await this.tenantService.GetTenantDoUsuario();
        this.tenant = resTenant.data;

        const res = await this.pacientesService.Get(pacienteId);
        this.paciente = res.data;
        this.paciente.dataNascimento = DateHelper.formataParaAnoMesDia(this.paciente.dataNascimento);

        if (this.paciente.listaConvenios && this.paciente.listaConvenios.length > 0) {
          if (this.paciente.listaConvenios[0]) {
            this.paciente.listaConvenios[0].vencimento = DateHelper.formataParaAnoMesDia(
              this.paciente.listaConvenios[0].vencimento,
            );
            if (this.paciente.listaConvenios[0].planoId === 0) {
              this.paciente.listaConvenios[0].planoId = undefined;
            }
            this.pacienteConvenioPrincipal = new PacientesConvenio(this.paciente.listaConvenios[0]);
          } else {
            this.pacienteConvenioPrincipal = new PacientesConvenio();
          }

          if (this.paciente.listaConvenios[1]) {
            this.paciente.listaConvenios[1].vencimento = DateHelper.formataParaAnoMesDia(
              this.paciente.listaConvenios[1].vencimento,
            );
            if (this.paciente.listaConvenios[1].planoId === 0) {
              this.paciente.listaConvenios[1].planoId = undefined;
            }
            this.pacienteConvenioSecundario = new PacientesConvenio(this.paciente.listaConvenios[1]);
          } else {
            this.pacienteConvenioSecundario = new PacientesConvenio();
          }
        }
      } catch (err) {
        AlertaSimplesErro('Erro ao carregar paciente:', err);
      } finally {
        this.carregando = false;
      }
    },
    fecharModal() {
      this.dialog = false;
      this.paciente = new Pacientes();
      this.pacienteConvenioPrincipal = new PacientesConvenio();
      this.pacienteConvenioSecundario = new PacientesConvenio();
    },
    apagarFoto() {
      this.paciente.foto = '';
    },
    async salvar() {
      try {
        const valid = await (this.$refs.observer as any).validate();

        if (!valid) {
          (this.$refs.form as any).scrollIntoView({ behavior: 'smooth' });
          return;
        }

        if ((this.paciente.observacaoPaciente?.length || 0) > 500) {
          MensagemMixin(3000, 'error', 'O texto excede o limite de 500 caracteres.');
          return;
        }

        if (this.paciente.cpf === null) {
          this.paciente.cpf = '';
        }

        if (new Date(this.paciente.dataNascimento) > new Date()) {
          MensagemMixin(3000, 'error', 'Não é possível cadastrar um paciente com o nascimento maior que hoje!');
          return;
        }

        const listaConvenios = [];

        if (this.pacienteConvenioPrincipal?.convenioId && this.pacienteConvenioPrincipal.convenioId !== 0) {
          const convenioPrincipal = {
            id: this.pacienteConvenioPrincipal.id || 0,
            convenioId: this.pacienteConvenioPrincipal.convenioId,
            planoId: this.pacienteConvenioPrincipal.planoId || null,
            numeroRegistro: this.pacienteConvenioPrincipal.numeroRegistro || '',
            vencimento: this.pacienteConvenioPrincipal.vencimento || '0001-01-01T00:00:00',
          };
          listaConvenios.push(convenioPrincipal);
        }

        if (this.pacienteConvenioSecundario?.convenioId && this.pacienteConvenioSecundario.convenioId !== 0) {
          const convenioSecundario = {
            id: this.pacienteConvenioSecundario.id || 0,
            convenioId: this.pacienteConvenioSecundario.convenioId,
            planoId: this.pacienteConvenioSecundario.planoId || null,
            numeroRegistro: this.pacienteConvenioSecundario.numeroRegistro || '',
            vencimento: this.pacienteConvenioSecundario.vencimento || '0001-01-01T00:00:00',
          };
          listaConvenios.push(convenioSecundario);
        }

        this.paciente.listaConvenios = JSON.stringify(listaConvenios);
        this.carregando = true;
        const postData = new FormData();
        this.appendFormData(postData, this.paciente);

        await this.pacientesService.Put(this.paciente.id, postData);
        MensagemMixin(3000, 'success', 'Paciente editado com sucesso.');
        this.$emit('pacienteEditado', this.paciente.id);
        this.fecharModal();
      } catch (err: any) {
        AlertaSimplesErro('Erro ao salvar:', err);
      } finally {
        this.carregando = false;
      }
    },
    appendFormData(formData: FormData, data: any, parentKey = ''): void {
      Object.keys(data).forEach((key) => {
        const value = data[key];
        const formKey = parentKey ? `${parentKey}.${key}` : key;

        if (value !== null && value !== undefined) {
          if (key === 'file' && (value instanceof Blob || value instanceof File)) {
            formData.append(formKey, value, 'avatar.png');
          } else if (typeof value === 'object' && !(value instanceof File) && !(value instanceof Blob)) {
            this.appendFormData(formData, value, formKey);
          } else {
            formData.append(formKey, value);
          }
        }
      });
    },
  },
});
</script>

<style scoped>
.headline {
  font-size: 1.25rem !important;
  font-weight: 500;
}
</style>
